import { render } from "./MenuNotConnected.vue?vue&type=template&id=4edc3274&scoped=true&ts=true"
import script from "./MenuNotConnected.vue?vue&type=script&lang=ts"
export * from "./MenuNotConnected.vue?vue&type=script&lang=ts"

import "./MenuNotConnected.vue?vue&type=style&index=0&id=4edc3274&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edc3274"]])

export default __exports__